import { useApi } from '@/api';
import { EntityName, Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function EventsTable({ pagination, sorting, filters }) {
  const [data, error] = useApi({
    url: '/surplus/events/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      ilk: filters.filtersApplied.ilk
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: '',
        getCell: (row) => (
          <Link to={`/collateral/${row.what}/${row.ilk}`}>
            <EntityName
              symbol1={
                <CryptoIcon
                  name={row.collateral_symbol}
                  address={row.collateral_address}
                  size="3"
                />
              }>
              <Flex gap="3xs" alignItems="flex-start" flexDirection="column">
                <Flex gap="3xs" alignItems="center">
                  {row.name}
                </Flex>
                <Flex gap="3xs" alignItems="center" color="muted" fontSize="-1">
                  {row.ilk}
                </Flex>
              </Flex>
            </EntityName>
          </Link>
        )
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Amount
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.amount} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap="3xs" color="muted" alignItems="center">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="-1" />
            </a>
          </Flex>
        ),
        sortingField: 'datetime',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <Flex gap="m" flexDirection="column">
        <DataTable
          rows={data['results']}
          columns={columns}
          getKey={(row) => row.order_index}
          sorting={sorting}
          pagination={{
            ...pagination,
            totalRecords: data.count
          }}
        />
      </Flex>
    );
  }
  return <TableSkeleton />;
}
